var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYellowBoatHatSelected = function SvgYellowBoatHatSelected(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 61,
    viewBox: "0 0 88 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2259 6.17084L34.1301 9.03866L38.2259 6.17084ZM51.7022 24.6146L51.4962 19.6188L51.7022 24.6146ZM50.8419 24.189L54.9377 21.3211L50.8419 24.189ZM70.304 24.3129L71.1878 29.2342L70.304 24.3129ZM70.7887 24.5068L75.4887 26.2127L70.7887 24.5068ZM70.5831 24.2628L69.6994 19.3415L70.5831 24.2628ZM63.4753 43.2541L64.4734 48.1535L63.4753 43.2541ZM64.2157 42.6154L59.5158 40.9094L64.2157 42.6154ZM37.4039 48.5026L38.153 43.559L37.4039 48.5026ZM37.7533 48.4938L38.7514 53.3931L37.7533 48.4938ZM13.1278 44.3181L17.7847 42.498L13.1278 44.3181ZM13.9093 44.9428L14.6584 39.9992L13.9093 44.9428ZM6.04289 26.1904L10.6999 24.3703L6.04289 26.1904ZM6.17663 25.927L8.34029 21.4193L6.17663 25.927ZM6.09838 25.677L6.2562 30.6745L6.09838 25.677ZM6.05768 25.8699L3.89402 30.3775L6.05768 25.8699ZM38.0157 6.03789L41.8044 9.3006L38.0157 6.03789ZM21.8097 24.8568L18.0209 21.5941L21.8097 24.8568ZM25.5984 28.1195L41.8044 9.3006L34.2269 2.77518L18.0209 21.5941L25.5984 28.1195ZM6.2562 30.6745L21.2413 30.2013L20.9257 20.2062L5.94057 20.6795L6.2562 30.6745ZM8.34029 21.4193L8.22134 21.3622L3.89402 30.3775L4.01297 30.4346L8.34029 21.4193ZM17.7847 42.498L10.6999 24.3703L1.38593 28.0105L8.4708 46.1382L17.7847 42.498ZM38.153 43.559L14.6584 39.9992L13.1603 49.8864L36.6549 53.4462L38.153 43.559ZM62.4773 38.3547L36.7553 43.5944L38.7514 53.3931L64.4734 48.1535L62.4773 38.3547ZM66.0887 22.8008L59.5158 40.9094L68.9157 44.3214L75.4887 26.2127L66.0887 22.8008ZM71.1878 29.2342L71.4669 29.1841L69.6994 19.3415L69.4203 19.3916L71.1878 29.2342ZM51.9083 29.6103L70.3441 28.8501L69.9321 18.8586L51.4962 19.6188L51.9083 29.6103ZM34.1301 9.03866L46.7461 27.0568L54.9377 21.3211L42.3217 3.30302L34.1301 9.03866ZM42.3217 3.30302C42.8974 4.12531 43.2063 5.10483 43.2063 6.10865H33.2063C33.2063 7.15697 33.5288 8.17992 34.1301 9.03866L42.3217 3.30302ZM51.4962 19.6188C52.8585 19.5626 54.1556 20.2042 54.9377 21.3211L46.7461 27.0568C47.9191 28.7321 49.8648 29.6946 51.9083 29.6103L51.4962 19.6188ZM72.9712 28.2547C77.3007 25.3905 75.1184 18.6447 69.9321 18.8586L70.3441 28.8501C65.4119 29.0535 63.3365 22.6382 67.4539 19.9145L72.9712 28.2547ZM69.4203 19.3916C74.6325 18.4556 77.3879 25.3329 72.9712 28.2547L67.4539 19.9145C62.8096 22.9868 65.7069 30.2184 71.1878 29.2342L69.4203 19.3916ZM75.4887 26.2127C76.852 22.4566 73.6324 18.6352 69.6994 19.3415L71.4669 29.1841C67.8132 29.8402 64.8222 26.2902 66.0887 22.8008L75.4887 26.2127ZM64.4734 48.1535C66.5203 47.7365 68.203 46.285 68.9157 44.3214L59.5158 40.9094C59.9909 39.6004 61.1127 38.6327 62.4773 38.3547L64.4734 48.1535ZM36.6549 53.4462C37.3514 53.5517 38.0611 53.5338 38.7514 53.3931L36.7553 43.5944C37.2155 43.5006 37.6886 43.4887 38.153 43.559L36.6549 53.4462ZM8.4708 46.1382C9.25161 48.136 11.0395 49.5651 13.1603 49.8864L14.6584 39.9992C16.0722 40.2135 17.2642 41.1661 17.7847 42.498L8.4708 46.1382ZM6.83888 21.131C2.98643 20.5792 -0.0307031 24.3858 1.38593 28.0105L10.6999 24.3703C12.0712 27.8792 9.15049 31.5641 5.42112 31.03L6.83888 21.131ZM4.01297 30.4346C-1.05967 27.9997 1.26905 20.3333 6.83888 21.131L5.42112 31.03C11.1748 31.854 13.5803 23.9346 8.34029 21.4193L4.01297 30.4346ZM5.94057 20.6795C0.602593 20.848 -0.92065 28.0664 3.89402 30.3775L8.22134 21.3622C12.8445 23.5814 11.3818 30.5126 6.2562 30.6745L5.94057 20.6795ZM41.8044 9.3006C38.8446 12.7377 33.2063 10.6443 33.2063 6.10865H43.2063C43.2063 1.37191 37.318 -0.814286 34.2269 2.77518L41.8044 9.3006ZM18.0209 21.5941C18.752 20.7451 19.8058 20.2416 20.9257 20.2062L21.2413 30.2013C22.9211 30.1482 24.5017 29.3931 25.5984 28.1195L18.0209 21.5941Z",
    fill: "#7EC2E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3282 33.6395L6 25.322L27.9491 24.6289L23.3282 33.6395Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3282 33.6395L6 25.322L27.9491 24.6289L23.3282 33.6395Z",
    fill: "url(#boat_hat_selected_paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6741 33.4086L48.2807 24.3979L70.6919 23.4738L55.6741 33.4086Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6741 33.4086L48.2807 24.3979L70.6919 23.4738L55.6741 33.4086Z",
    fill: "url(#boat_hat_selected_paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3146 41.1733L38.4042 5.82217L58.4382 34.4347L42.2655 43.5364L38.3146 41.1733Z",
    fill: "url(#boat_hat_selected_paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4162 5.51389L15.0873 32.6041L38.4162 40.5771V5.51389Z",
    fill: "url(#boat_hat_selected_paint3_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1151 5.73871L14.7862 32.829L38.1151 40.8019V5.73871Z",
    fill: "url(#boat_hat_selected_paint4_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6297 44.4251L6.30804 25.6915L36.571 30.0258L71 23.8431L64.1494 42.7167L37.7913 48.086L13.6297 44.4251Z",
    fill: "url(#boat_hat_selected_paint5_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3217 44.1168L6 25.3831L36.263 29.7175L70.692 23.5348L63.8413 42.4084L37.4833 47.7776L13.3217 44.1168Z",
    fill: "url(#boat_hat_selected_paint6_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3217 44.1168L6 25.3831L36.263 29.7175L70.692 23.5348L63.8413 42.4084L37.4833 47.7776L13.3217 44.1168Z",
    fill: "url(#boat_hat_selected_paint7_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4126 39C69.8926 39 65.4126 43.48 65.4126 49C65.4126 54.52 69.8926 59 75.4126 59C80.9326 59 85.4126 54.52 85.4126 49C85.4126 43.48 80.9326 39 75.4126 39ZM72.7026 53.29L69.1126 49.7C68.7226 49.31 68.7226 48.68 69.1126 48.29C69.5026 47.9 70.1326 47.9 70.5226 48.29L73.4126 51.17L80.2926 44.29C80.6826 43.9 81.3126 43.9 81.7026 44.29C82.0926 44.68 82.0926 45.31 81.7026 45.7L74.1126 53.29C73.7326 53.68 73.0926 53.68 72.7026 53.29Z",
    fill: "#7EC2E4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint0_linear",
    x1: 16.9745,
    y1: 24.6289,
    x2: 16.9745,
    y2: 33.6395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint1_linear",
    x1: 59.4863,
    y1: 23.4738,
    x2: 59.4863,
    y2: 33.4086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint2_linear",
    x1: 60.2988,
    y1: -16.612,
    x2: 44.2955,
    y2: 74.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FDC73C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint3_linear",
    x1: 33.4932,
    y1: -4.6517,
    x2: 33.9553,
    y2: 69.3569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint4_linear",
    x1: 38.1911,
    y1: 26.2302,
    x2: 8.07938,
    y2: -4.88264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint5_linear",
    x1: 38.6531,
    y1: 15.5869,
    x2: 6.39635,
    y2: 89.8057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint6_linear",
    x1: 37.883,
    y1: 35.3946,
    x2: 38.3451,
    y2: 64.9513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC73C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "boat_hat_selected_paint7_linear",
    x1: -33.6612,
    y1: 33.1613,
    x2: 97.5673,
    y2: 33.0073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856273,
    stopColor: "#FDC73C"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowBoatHatSelected, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellow_boat_hat_selected.b249b73e.svg";
export { ForwardRef as ReactComponent };